import React, { useState } from "react";

import { useAuth } from "../providers/auth";
import { useNavigate } from "react-router-dom";

//core-ui
import {
  CAvatar,
  CTableRow,
  CTableDataCell
} from "@coreui/react";

import api from "../services/api";
import openToast from "../utils/sweetAlert";

import Dropdown from "../components/dropdown/Dropdown";
import DropdownLink from "../components/dropdown/DropdownLink";

const VacationTableRow = props => {
  const { admin } = props;
  const { user } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [onVacation, setOnVacation] = useState(admin.ferias);

  const token = { headers: { "Authorization": "Bearer " + user.token } };

  const openAdmin = (e) => {
    e.preventDefault();
    navigate("/vacation-tool/" + admin.id);
  }

  const comeOffVacation = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post("/admins/vacation/back", { admin_id: admin.id }, token);

      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);
        setOnVacation(false);
      }

      if (response.data.error) {
        openToast("error", "Erro", response.data.message);
      }
    } catch (e) {
      openToast("error", "Erro", "Ocorreu um erro.");
    } finally {
      setLoading(false);
    }
  }

  const avatarStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${admin.profile_picture})`
  };

  return (
    <CTableRow key={admin.id}>
      <CTableDataCell className="align-middle">
        <CAvatar color="light" textColor="dark" style={avatarStyle}></CAvatar>
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        <span className="text-color">{admin.name}</span>
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        <Dropdown bttnSize={34}>
          {!onVacation
            ? <DropdownLink to="/" onClick={openAdmin}>Férias</DropdownLink>
            : <DropdownLink to="/" onClick={comeOffVacation}>
                {loading ? "Carregando..." : "Tirar de férias"}
              </DropdownLink>}
          <DropdownLink to="/" onClick={e => props.setAdmin(e, admin)}>Transferir clientes</DropdownLink>
          <DropdownLink to="/" onClick={e => props.setLiberate(e, admin)}>Liberar clientes</DropdownLink>
        </Dropdown>
      </CTableDataCell>
    </CTableRow>
  );
}

export default VacationTableRow;